import classnames from "classnames";
import React from "react";

import { IHotjarProps, ITestable, testAttr } from "@/browser";
import { LazyImg } from "@/components/Fetcher";
import { IAttachment } from "@/data/attachments";
import { Avatar as EworkitAvatar, IAvatarProps as IEworkitAvatarProps } from "@/eworkitComponents";

import "./_avatar.scss";

export interface IAvatarProps extends Omit<IEworkitAvatarProps, "imageUrl">, ITestable, IHotjarProps {
  avatar?: IAttachment | null;
  firstName: string;
  lastName: string;
  size?: IEworkitAvatarProps["size"] | "profile" | "profile-big";
}

export class Avatar extends React.PureComponent<IAvatarProps> {
  static defatulProps: Partial<IAvatarProps> = {
    hjSuppress: true,
    size: "md",
    className: "-word-break-all",
  };

  renderImg = ({ payload }: { payload?: IAttachment }) => {
    return !payload ? null : this.renderAvatar(payload);
  };

  renderAvatar = (attachment?: IAttachment) => {
    const { avatar, firstName, lastName, ...restProps } = this.props;
    return (
      <EworkitAvatar
        imageUrl={attachment && attachment.publicUrl ? attachment.publicUrl : undefined}
        initials={[firstName, lastName]}
        {...restProps}
      />
    );
  };

  render() {
    const { avatar, className, size } = this.props;

    const classes = classnames(
      "avatar",
      {
        [`avatar--size-${size}`]: !!size,
      },
      className,
    );

    return (
      <div className={classes} {...testAttr(this.props, { sufix: "avatar" })}>
        {avatar ? (
          avatar.publicUrl ? (
            this.renderAvatar(avatar)
          ) : (
            <LazyImg key={avatar.id} systemId={avatar.systemId}>
              {this.renderImg}
            </LazyImg>
          )
        ) : (
          this.renderAvatar()
        )}
      </div>
    );
  }
}
